import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const SplitLocationGroupSelectionSchema_ = z.object({
  profileId: z.string(),
  locationGroupId: z.string(),
});
export const SplitLocationGroupSelectionSchema: z.ZodType<SplitLocationGroupSelectionSchema> =
  SplitLocationGroupSelectionSchema_;
export interface SplitLocationGroupSelectionSchema extends z.infer<
  typeof SplitLocationGroupSelectionSchema_
> {}

export const splitLocationGroups = {
  name: "splitLocationGroups" as const,
  input: z.object({
    teamId: zExt.objectId(),
    selections: z.array(SplitLocationGroupSelectionSchema),
  }),
  output: z.object({
    success: z.boolean(),
    profilesUpdated: z.number(),
    locationGroupsSplit: z.number(),
    errors: z.array(z.string()).optional(),
  }),
};
